import { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Layout from "../../../components/layout/Layout";
import Admin from "../../../components/auth/Admin";
import ProductContainers from "./ProductContainers";
import PurchaseContainers from "./PurchaseContainers";
import Notification from "../../../components/customHelpers/Notification";
import Notify from "../../../components/customHelpers/Notify";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`container-tabpanel-${index}`}
      aria-labelledby={`container-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  tabContainer: {
    marginBottom: theme.spacing(1),
  },
  tabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(4),
      fontSize: "1rem",
      fontWeight: 500,
      textTransform: "none",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
      height: 3,
    },
  },
}));

const Container = () => {
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Box
            sx={{ borderBottom: 1, borderColor: "divider" }}
            className={classes.tabContainer}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              className={classes.tabs}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Product Containers" />
              <Tab label="Purchase Containers" />
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0} className={classes.tabContent}>
            <ProductContainers NotifyMessage={NotifyMessage} />
          </TabPanel>
          <TabPanel value={tabValue} index={1} className={classes.tabContent}>
            <PurchaseContainers NotifyMessage={NotifyMessage} />
          </TabPanel>

          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};

export default Container;